import React, { Component, useState } from "react";
import {
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Tooltip,
  ListItemButton,
  Collapse,
  List,
  IconButton,
} from "@mui/material";
import {
  Home as IconHome,
  Menu as IconMenu,
  PowerSettingsNew as IconLogout,
  Group as IconUsers,
  FolderCopy as IconProjects,
  CloudUpload as IconUpload,
  InsertChart as IconChart,
  Dashboard as IconDashboard,
  AccountBalance as IconOrg,
  CheckBoxOutlined as IconApprove,
  Settings as IconSettings,
  PermMedia as IconProjectStatus,
  Margin as IconResourcePlanning,
  PunchClock as IconTimeSheet,
  ExpandLess,
  ExpandMore,
  Dns as IconMaster,
  TextSnippet as IconReports,
  GridOn as IconGrid,
  Groups as IconMeeting,
  GridView as IconCrmDashboard,
  ManageAccounts as IconCrm,
  PeopleOutline as IconLeadProfile,
  OndemandVideo as IconTraining,
  Functions as IconRoi,
  ContentCopy as IconCrmReports,
  Store as IconCustomers,
  Diversity3 as IconTeam,
  LocalGroceryStore as IconOrders,
  MonetizationOn as IconSales,
  ShoppingCart as IconPurchase,
  Receipt as IconPhysicalVoucher,
  PersonPin as IconCustomerOnMap,
  InsertChart as IconGraphDashboard,
  NoteAdd as IconTransactions,
  Payment as IconPayment,
  Public as IconAiMap,
  Route as IconScavenging,
  AccountBoxRounded as IconAccount,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";

import ConfirmDialog from "components/Custom/ConfirmDialog";

import {
  DEFAULTS,
  NOTIFY,
  LOCAL_STORAGE,
  CONFIG,
  LIVE_MENUS,
} from "common/config";
import { CONFIRMS, LABELS, SUCCESS, ERRORS, TITLES } from "common/lables";
import { AUTH_APIs } from "apihandlers/auth";
import { COMMON_JS } from "common/scripts";
import TrainingView from "components/Training/TrainingView";

const RELEASE_MENUS = process.env.REACT_APP_RELEASE_MENUS === "true";

const LeftBar = (props: any) => {
  const { page, setPage, userInfo, childRef, privileges } = props;
  const [leftBar, setLeftBar] = useState(false);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [showMasterMenu, setShowMasterMenu] = useState(false);
  const [showReportsMenu, setShowReportsMenu] = useState(false);
  const [showTrainingMenu, setShowTrainingMenu] = useState(false);
  const [showCrmMenu, setShowCrmMenu] = useState(false);
  const [showSalesMenu, setShowSalesMenu] = useState(false);
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showPurchaseMenu, setShowPurchaseMenu] = useState(false);
  const [showCustomerMenu, setCustomerMenu] = useState(false);
  const [showTeamMenu, setTeamMenu] = useState(false);
  const [showOrderMenu, setOrderMenu] = useState(false);

  const onUserLogout = () => {
    AUTH_APIs.logout({}).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.LOGOUT_SUCCESS);
        localStorage.removeItem(LOCAL_STORAGE.USER_INFO);
        localStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN);
        setLogoutPopup(false);
        setTimeout(() => {
          window.open("/login", "_self");
        }, 500);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.LOGOUT_FAILED);
      }
    });
  };

  const onSetLeftBar = (val: boolean) => {
    setLeftBar(val);
    if (val) {
      (document.querySelector(".content") as HTMLElement).classList.add(
        "active"
      );
    } else {
      (document.querySelector(".content") as HTMLElement).classList.remove(
        "active"
      );
      setShowMasterMenu(false);
    }
  };

  const roleId = userInfo.role.id;

  let mainMasterAccess = roleId === CONFIG.USER_ROLES.Admin;

  let tripEntryAccess =
    roleId === CONFIG.USER_ROLES.Admin ||
    roleId === CONFIG.USER_ROLES.Placement;

  let masterEntryLevel = false;
  let transactionEntryLevel = false;
  if (roleId === CONFIG.USER_ROLES.Admin) {
    masterEntryLevel = true;
    transactionEntryLevel = true;
  } else {
    masterEntryLevel = true;
    transactionEntryLevel = true;
  }

  let menuAdmin = roleId === CONFIG.USER_ROLES.Admin;

  let menuMaster = privileges.Master && true;
  let crmMenu = true;
  let trainingMenu = true;
  let trainingAssign = true;
  let trainingView = true;
  let trainingUpload = true;
  let salesMenu = true;
  let menuCrmDashboard = true;
  let menuSalesOrder = true;
  let menuSalesInvoice = true;
  let menuSalesReturn = true;
  let menuCreditNote = true;
  let menuCreditApproval = true;
  let menuAddSalesInvoice = true;
  let menuEInvoice = true;
  let accountMenu = true;
  let menuBalanceConfirmation = true;
  let menucrmTransaction = true;
  let menuCrmLeadProfile = true;
  let purchaseMenu = true;
  let menuAddPurchaseBill = true;
  let menuPurchaseBill = true;
  let menuPurchaseReturn = true;
  let menuPhysicalVoucher = true;
  let menuCrmFeedback = true;
  let menuCrmSurvey = true;
  let menuRoi = true;
  let menuCrmReports = true;
  let customerMenu = true;
  let customer = true;
  let customerType = true;
  let teamMenu = true;
  let PJP = true;
  let Ledger = true;
  let LeaveApplication = true;
  let attendance = true;
  let track = true;
  let orderMenu = true;
  let stockLoad = true;
  let order = true;
  let Challan = true;
  let Invoice = true;
  let Return = true;
  let loadReturn = true;
  let leaveApproval = true;
  let primaryOrder = true;
  let ordersLifecycle = true;
  let CRMLifecycle = true;
  let menuCustomersOnMap = true;
  let menuCrmLeadProfileImport = true;
  let uploadTdsPayment = true;
  let tdsConfirmatiom = true;
  let aiMapMenu = true;
  let reportsMenu = true;
  let transactionsMenu = true;
  let dmsReportsMenu = true;

  if (childRef) {
    childRef.hideCrmMenu = () => {
      setShowCrmMenu(false);
    };
  }

  if (LIVE_MENUS) {
    menuCustomersOnMap = false;
    aiMapMenu = false;
    reportsMenu = false;
    menuMaster = false;
    transactionsMenu = false;
    trainingMenu = false;
    accountMenu = false;
    salesMenu = false;
    purchaseMenu = false;
    dmsReportsMenu = false;
  }

  return (
    <div className={"leftBar " + (leftBar ? "active" : "")}>
      <MenuList className="leftMenuWrapper">
        <MenuItem className={"leftMenu"} onClick={() => onSetLeftBar(!leftBar)}>
          <ListItemIcon>
            <IconMenu fontSize="small" />
          </ListItemIcon>
          <div>
            <h4>
              {CONFIG.SITE_NAME} <small>{CONFIG.VERSION}</small>
            </h4>
            {/* <img src={logoSmall} className="responsive" /> */}
          </div>
        </MenuItem>

        <MenuItem
          className={
            "leftMenu " +
            (page === LABELS.HOME || page === LABELS.MENU || page === ""
              ? "active"
              : "")
          }
          onClick={() => setPage(LABELS.HOME)}
        >
          <Tooltip title={LABELS.HOME} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconHome fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.HOME}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {menuCustomersOnMap && (
          <MenuItem
            className={
              "leftMenu " + (page === TITLES.CUSTOMERS_ON_MAP ? "active" : "")
            }
            onClick={() => setPage(TITLES.CUSTOMERS_ON_MAP)}
          >
            <Tooltip title={TITLES.CUSTOMERS_ON_MAP} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconAiMap fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {TITLES.CUSTOMERS_ON_MAP}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {aiMapMenu && (
          <MenuItem
            className={"leftMenu " + (page === TITLES.AI_MAP ? "active" : "")}
            onClick={() => setPage(TITLES.AI_MAP)}
          >
            <Tooltip title={TITLES.AI_MAP} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconAiMap fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {TITLES.AI_MAP}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {reportsMenu && (
          <ListItemButton
            onClick={() => {
              setShowReportsMenu(!showReportsMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconGraphDashboard />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.REPORTS}
              />
            )}
            {leftBar && (showReportsMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showReportsMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <MenuItem
              className={
                "leftMenu subMenu " + (page === LABELS.REPORTS ? "active" : "")
              }
              onClick={() => setPage(LABELS.REPORTS)}
            >
              <Tooltip title={LABELS.REPORTS} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconReports fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">
                    {LABELS.REPORTS}
                  </ListItemText>
                </div>
              </Tooltip>
            </MenuItem>
            <MenuItem
              className={
                "leftMenu subMenu " +
                (page === TITLES.CRM_REPORTS ? "active" : "")
              }
              onClick={() => setPage(TITLES.CRM_REPORTS)}
            >
              <Tooltip title={TITLES.CRM_REPORTS} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconReports fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">
                    {TITLES.CRM_REPORTS}
                  </ListItemText>
                </div>
              </Tooltip>
            </MenuItem>
            <MenuItem
              className={
                "leftMenu subMenu " +
                (page === TITLES.POS_REPORT ? "active" : "")
              }
              onClick={() => setPage(TITLES.POS_REPORT)}
            >
              <Tooltip title={TITLES.POS_REPORT} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconReports fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">
                    {TITLES.POS_REPORT}
                  </ListItemText>
                </div>
              </Tooltip>
            </MenuItem>

            <MenuItem
              className={
                "leftMenu subMenu " + (page === TITLES.TRAINING ? "active" : "")
              }
              onClick={() => setPage(TITLES.TRAINING)}
            >
              <Tooltip title={TITLES.TRAINING} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconReports fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">
                    {TITLES.TRAINING}
                  </ListItemText>
                </div>
              </Tooltip>
            </MenuItem>

            <MenuItem
              className={
                "leftMenu subMenu " + (page === LABELS.KPI ? "active" : "")
              }
              onClick={() => setPage(LABELS.KPI)}
            >
              <Tooltip title={LABELS.KPI} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconReports fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">{LABELS.KPI}</ListItemText>
                </div>
              </Tooltip>
            </MenuItem>
            <MenuItem
              className={
                "leftMenu subMenu " +
                (page === TITLES.GRAPH_DASHBOARD ? "active" : "")
              }
              onClick={() => setPage(TITLES.GRAPH_DASHBOARD)}
            >
              <Tooltip title={TITLES.GRAPH_DASHBOARD} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconGraphDashboard fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">
                    {TITLES.GRAPH_DASHBOARD}
                  </ListItemText>
                </div>
              </Tooltip>
            </MenuItem>
          </List>
        </Collapse>

        {menuMaster && (
          <MenuItem
            className={"leftMenu " + (page === LABELS.MASTERS ? "active" : "")}
            onClick={() => setPage(LABELS.MASTERS)}
          >
            <Tooltip title={LABELS.MASTERS} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconMaster fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.MASTERS}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {transactionsMenu && (
          <MenuItem
            className={
              "leftMenu " + (page === LABELS.TRANSACTION ? "active" : "")
            }
            onClick={() => setPage(LABELS.TRANSACTION)}
          >
            <Tooltip title={LABELS.TRANSACTION} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconTransactions fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {LABELS.TRANSACTION}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        {crmMenu && (
          <ListItemButton
            onClick={() => {
              setShowCrmMenu(!showCrmMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconCrm />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.CRM}
              />
            )}
            {leftBar && (showCrmMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showCrmMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menuCrmDashboard && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CRM_DASHBOARD ? "active" : "")
                }
                onClick={() => setPage(TITLES.CRM_DASHBOARD)}
              >
                <Tooltip title={TITLES.CRM_DASHBOARD} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CRM_DASHBOARD}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {menuCrmLeadProfile && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.LEAD_PROFILE ? "active" : "")
                }
                onClick={() => setPage(TITLES.LEAD_PROFILE)}
              >
                <Tooltip title={TITLES.LEAD_PROFILE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.LEAD_PROFILE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {/* {menuCrmFeedback && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.FEEDBACK ? "active" : "")
                }
                onClick={() => setPage(TITLES.FEEDBACK)}
              >
                <Tooltip title={TITLES.FEEDBACK} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.FEEDBACK}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {menuCrmSurvey && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.SURVEY ? "active" : "")
                }
                onClick={() => setPage(TITLES.SURVEY)}
              >
                <Tooltip title={TITLES.SURVEY} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.SURVEY}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {menuRoi && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.ROI ? "active" : "")
                }
                onClick={() => setPage(TITLES.ROI)}
              >
                <Tooltip title={TITLES.ROI} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconRoi />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.ROI}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}

            {/* {menuCrmReports && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.INSTRUCTIONS ? "active" : "")
                }
                onClick={() => setPage(TITLES.INSTRUCTIONS)}
              >
                <Tooltip title={TITLES.INSTRUCTIONS} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmReports fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.INSTRUCTIONS}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}

            <MenuItem
              className={
                "leftMenu subMenu " +
                (page === TITLES.SCAVENGING ? "active" : "")
              }
              onClick={() => setPage(TITLES.SCAVENGING)}
            >
              <Tooltip title={TITLES.SCAVENGING} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconScavenging fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">
                    {TITLES.SCAVENGING}
                  </ListItemText>
                </div>
              </Tooltip>
            </MenuItem>

            {menucrmTransaction && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CRM_TRANSACTION ? "active" : "")
                }
                onClick={() => setPage(TITLES.CRM_TRANSACTION)}
              >
                <Tooltip
                  title={TITLES.CRM_TRANSACTION}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CRM_TRANSACTION}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {/* todo streetview to be added here */}

            {CRMLifecycle && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CRM_LIFECYCLE ? "active" : "")
                }
                onClick={() => setPage(TITLES.CRM_LIFECYCLE)}
              >
                <Tooltip title={TITLES.CRM_LIFECYCLE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconReports fontSize="small" />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CRM_LIFECYCLE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse>

        {trainingMenu && (
          <ListItemButton
            onClick={() => {
              setShowTrainingMenu(!showTrainingMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconCrm />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.TRAINING}
              />
            )}
            {leftBar && (showTrainingMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showTrainingMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {trainingAssign && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.TRAINING_ASSIGN ? "active" : "")
                }
                onClick={() => setPage(TITLES.TRAINING_ASSIGN)}
              >
                <Tooltip
                  title={TITLES.TRAINING_ASSIGN}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.TRAINING_ASSIGN}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {trainingUpload && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.TRAINING_UPLOAD ? "active" : "")
                }
                onClick={() => setPage(TITLES.TRAINING_UPLOAD)}
              >
                <Tooltip
                  title={TITLES.TRAINING_UPLOAD}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.TRAINING_UPLOAD}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {trainingView && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.TRAINING_VIEW ? "active" : "")
                }
                onClick={() => setPage(TITLES.TRAINING_VIEW)}
              >
                <Tooltip title={TITLES.TRAINING_VIEW} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.TRAINING_VIEW}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse>

        {/*
        <MenuItem
          className={
            "leftMenu " + (page === TITLES.ROI_DASHBOARD ? "active" : "")
          }
          onClick={() => setPage(TITLES.ROI_DASHBOARD)}
        >
          <Tooltip title={TITLES.ROI_DASHBOARD} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconMaster fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {TITLES.ROI_DASHBOARD}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>
        

        {/*
        <MenuItem
          className={"leftMenu " + (page === LABELS.CUSTOMERS ? "active" : "")}
          onClick={() => setPage(LABELS.CUSTOMERS)}
        >
          <Tooltip title={LABELS.CUSTOMERS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconCustomers fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.CUSTOMERS}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        {teamMenu && (
          <ListItemButton
            onClick={() => {
              setTeamMenu(!showTeamMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconTeam />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.TEAM}
              />
            )}
            {leftBar && (showTeamMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )} */}
        {/* <Collapse in={showTeamMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {PJP && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.PJP ? "active" : "")
                }
                onClick={() => setPage(TITLES.PJP)}
              >
                <Tooltip title={TITLES.PJP} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.PJP}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {Ledger && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.LEDGER ? "active" : "")
                }
                onClick={() => setPage(TITLES.LEDGER)}
              >
                <Tooltip title={TITLES.LEDGER} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.LEDGER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {LeaveApplication && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.LEAVE_APPLICATION ? "active" : "")
                }
                onClick={() => setPage(TITLES.LEAVE_APPLICATION)}
              >
                <Tooltip
                  title={TITLES.LEAVE_APPLICATION}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.LEAVE_APPLICATION}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {leaveApproval && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.LEAVE_APPROVAL ? "active" : "")
                }
                onClick={() => setPage(TITLES.LEAVE_APPROVAL)}
              >
                <Tooltip
                  title={TITLES.LEAVE_APPROVAL}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.LEAVE_APPROVAL}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {attendance && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.ATTENDENCE ? "active" : "")
                }
                onClick={() => setPage(TITLES.ATTENDENCE)}
              >
                <Tooltip title={TITLES.ATTENDENCE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.ATTENDENCE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {track && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.TRACK ? "active" : "")
                }
                onClick={() => setPage(TITLES.TRACK)}
              >
                <Tooltip title={TITLES.TRACK} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.TRACK}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse> */}
        {/* {orderMenu && (
          <ListItemButton
            onClick={() => {
              setOrderMenu(!showOrderMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconOrders />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.ORDERS}
              />
            )}
            {leftBar && (showOrderMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )} */}
        {/* <Collapse in={showOrderMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {stockLoad && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.STOCK_LOAD ? "active" : "")
                }
                onClick={() => setPage(TITLES.STOCK_LOAD)}
              >
                <Tooltip title={TITLES.STOCK_LOAD} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.STOCK_LOAD}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {order && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.ORDER ? "active" : "")
                }
                onClick={() => setPage(TITLES.ORDER)}
              >
                <Tooltip title={TITLES.ORDER} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.ORDER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {Challan && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CHALLAN ? "active" : "")
                }
                onClick={() => setPage(TITLES.CHALLAN)}
              >
                <Tooltip title={TITLES.CHALLAN} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CHALLAN}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {Invoice && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.INVOICE ? "active" : "")
                }
                onClick={() => setPage(TITLES.INVOICE)}
              >
                <Tooltip title={TITLES.INVOICE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.INVOICE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {Return && (
              <MenuItem
                className={
                  "leftMenu subMenu " + (page === TITLES.RETURN ? "active" : "")
                }
                onClick={() => setPage(TITLES.RETURN)}
              >
                <Tooltip title={TITLES.RETURN} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.RETURN}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {loadReturn && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.LOAD_RETURN ? "active" : "")
                }
                onClick={() => setPage(TITLES.LOAD_RETURN)}
              >
                <Tooltip title={TITLES.LOAD_RETURN} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.LOAD_RETURN}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {primaryOrder && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.PRIMARY_ORDER ? "active" : "")
                }
                onClick={() => setPage(TITLES.PRIMARY_ORDER)}
              >
                <Tooltip title={TITLES.PRIMARY_ORDER} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.PRIMARY_ORDER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {ordersLifecycle && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.ORDERS_LIFECYCLE ? "active" : "")
                }
                onClick={() => setPage(TITLES.ORDERS_LIFECYCLE)}
              >
                <Tooltip
                  title={TITLES.ORDERS_LIFECYCLE}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconLeadProfile />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.ORDERS_LIFECYCLE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse>

        <MenuItem
          className={"leftMenu " + (page === LABELS.TRAINING ? "active" : "")}
          onClick={() => setPage(LABELS.TRAINING)}
        >
          <Tooltip title={LABELS.TRAINING} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconTraining fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.TRAINING}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem> */}

        {/* {masterEntryLevel && (
          <ListItemButton
            onClick={() => {
              setShowMasterMenu(!showMasterMenu);
            }}
            style={{
              paddingLeft: 20,
            }}
          >
            <ListItemIcon
              style={{
                minWidth: 26,
                position: "relative",
                left: leftBar ? 0 : -5,
              }}
            >
              <IconMaster style={{ fontSize: 18 }} />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText"
                primary="Masters"
                style={{
                  textAlign: "left",
                  color: "#fff",
                  marginLeft: 18,
                }}
              />
            )}
            {leftBar && (showMasterMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showMasterMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.HOLIDAY_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.HOLIDAY_MASTER)}
              >
                <Tooltip
                  title={LABELS.HOLIDAY_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.HOLIDAY_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.TASK_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.TASK_MASTER)}
              >
                <Tooltip title={LABELS.TASK_MASTER} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.TASK_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.GPT_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.GPT_MASTER)}
              >
                <Tooltip title={LABELS.GPT_MASTER} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.GPT_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.PRICE ? "active" : "")
                }
                onClick={() => setPage(LABELS.PRICE)}
              >
                <Tooltip title={LABELS.PRICE} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.PRICE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.SCHEME ? "active" : "")
                }
                onClick={() => setPage(LABELS.SCHEME)}
              >
                <Tooltip title={LABELS.SCHEME} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.SCHEME}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.PROJECT_TYPE_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.PROJECT_TYPE_MASTER)}
              >
                <Tooltip
                  title={LABELS.PROJECT_TYPE_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.PROJECT_TYPE_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.PROJECTS ? "active" : "")
                }
                onClick={() => setPage(LABELS.PROJECTS)}
              >
                <Tooltip title={LABELS.PROJECTS} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.PROJECTS}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.RESPONSIBILITY_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.RESPONSIBILITY_MASTER)}
              >
                <Tooltip
                  title={LABELS.RESPONSIBILITY_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.RESPONSIBILITY_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.WORK_PACKAGES ? "active" : "")
                }
                onClick={() => setPage(LABELS.WORK_PACKAGES)}
              >
                <Tooltip title={LABELS.WORK_PACKAGES} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.WORK_PACKAGES}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.DESIGNATION_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.DESIGNATION_MASTER)}
              >
                <Tooltip
                  title={LABELS.DESIGNATION_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.DESIGNATION_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {masterEntryLevel && (
              <MenuItem
                className={
                  "leftMenu " +
                  (page === LABELS.EMPLOYEE_MASTER ? "active" : "")
                }
                onClick={() => setPage(LABELS.EMPLOYEE_MASTER)}
              >
                <Tooltip
                  title={LABELS.EMPLOYEE_MASTER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.EMPLOYEE_MASTER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {menuAdmin && (
              <MenuItem
                className={
                  "leftMenu " + (page === LABELS.USERS ? "active" : "")
                }
                onClick={() => setPage(LABELS.USERS)}
              >
                <Tooltip title={LABELS.USERS} placement={"right-start"}>
                  <div>
                    <ListItemIcon></ListItemIcon>
                    <ListItemText className="menuText">
                      {LABELS.USERS}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse> */}

        {accountMenu && (
          <ListItemButton
            onClick={() => {
              setShowAccountMenu(!showAccountMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconAccount />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.ACCOUNT}
              />
            )}
            {leftBar && (showAccountMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showAccountMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <MenuItem
              className={
                "leftMenu subMenu " + (page === LABELS.PAYMENT ? "active" : "")
              }
              onClick={() => setPage(LABELS.PAYMENT)}
            >
              <Tooltip title={LABELS.PAYMENT} placement={"right-start"}>
                <div>
                  <ListItemIcon>
                    <IconPayment fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="menuText">
                    {LABELS.PAYMENT}
                  </ListItemText>
                </div>
              </Tooltip>
            </MenuItem>
            {menuCreditNote && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CREDIT_NOTE ? "active" : "")
                }
                onClick={() => setPage(TITLES.CREDIT_NOTE)}
              >
                <Tooltip title={TITLES.CREDIT_NOTE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CREDIT_NOTE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuCreditApproval && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.CREDIT_APPROVAL ? "active" : "")
                }
                onClick={() => setPage(TITLES.CREDIT_APPROVAL)}
              >
                <Tooltip
                  title={TITLES.CREDIT_APPROVAL}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.CREDIT_APPROVAL}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuPhysicalVoucher && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.PHYSICAL_VOUCHER ? "active" : "")
                }
                onClick={() => setPage(TITLES.PHYSICAL_VOUCHER)}
              >
                <Tooltip
                  title={TITLES.PHYSICAL_VOUCHER}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.PHYSICAL_VOUCHER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuBalanceConfirmation && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.BALANCE_CONFIRMATION ? "active" : "")
                }
                onClick={() => setPage(TITLES.BALANCE_CONFIRMATION)}
              >
                <Tooltip
                  title={TITLES.BALANCE_CONFIRMATION}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.BALANCE_CONFIRMATION}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {tdsConfirmatiom && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.TDS_CONFIRMATION ? "active" : "")
                }
                onClick={() => setPage(TITLES.TDS_CONFIRMATION)}
              >
                <Tooltip
                  title={TITLES.TDS_CONFIRMATION}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.TDS_CONFIRMATION}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {uploadTdsPayment && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.UPLOAD_TDS_PAYMENT ? "active" : "")
                }
                onClick={() => setPage(TITLES.UPLOAD_TDS_PAYMENT)}
              >
                <Tooltip
                  title={TITLES.UPLOAD_TDS_PAYMENT}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.UPLOAD_TDS_PAYMENT}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse>

        {salesMenu && (
          <ListItemButton
            onClick={() => {
              setShowSalesMenu(!showSalesMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconSales />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.SALES}
              />
            )}
            {leftBar && (showSalesMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showSalesMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menuSalesOrder && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.SALES_ORDER ? "active" : "")
                }
                onClick={() => setPage(TITLES.SALES_ORDER)}
              >
                <Tooltip title={TITLES.SALES_ORDER} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.SALES_ORDER}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuAddSalesInvoice && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.ADD_SALES_INVOICE ? "active" : "")
                }
                onClick={() => setPage(TITLES.ADD_SALES_INVOICE)}
              >
                <Tooltip
                  title={TITLES.ADD_SALES_INVOICE}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.ADD_SALES_INVOICE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuSalesInvoice && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.SALES_INVOICE ? "active" : "")
                }
                onClick={() => setPage(TITLES.SALES_INVOICE)}
              >
                <Tooltip title={TITLES.SALES_INVOICE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.SALES_INVOICE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
            {menuSalesReturn && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.SALES_RETURN ? "active" : "")
                }
                onClick={() => setPage(TITLES.SALES_RETURN)}
              >
                <Tooltip title={TITLES.SALES_RETURN} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.SALES_RETURN}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {/* {menuEInvoice && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.E_INVOICE ? "active" : "")
                }
                onClick={() => setPage(TITLES.E_INVOICE)}
              >
                <Tooltip title={TITLES.E_INVOICE} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.E_INVOICE}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )} */}
          </List>
        </Collapse>

        {purchaseMenu && (
          <ListItemButton
            onClick={() => {
              setShowPurchaseMenu(!showPurchaseMenu);
            }}
            className="leftDropDownMenu"
          >
            <ListItemIcon className="leftDropDownMenuIcon">
              <IconPurchase />
            </ListItemIcon>
            {leftBar && (
              <ListItemText
                className="menuText leftDropDownMenuText"
                primary={LABELS.PURCHASE}
              />
            )}
            {leftBar && (showPurchaseMenu ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}
        <Collapse in={showPurchaseMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menuAddPurchaseBill && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.ADD_PURCHASE_BILL ? "active" : "")
                }
                onClick={() => setPage(TITLES.ADD_PURCHASE_BILL)}
              >
                <Tooltip
                  title={TITLES.ADD_PURCHASE_BILL}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.ADD_PURCHASE_BILL}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {menuPurchaseBill && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.PURCHASE_BILL ? "active" : "")
                }
                onClick={() => setPage(TITLES.PURCHASE_BILL)}
              >
                <Tooltip title={TITLES.PURCHASE_BILL} placement={"right-start"}>
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.PURCHASE_BILL}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}

            {menuPurchaseReturn && (
              <MenuItem
                className={
                  "leftMenu subMenu " +
                  (page === TITLES.PURCHASE_RETURN ? "active" : "")
                }
                onClick={() => setPage(TITLES.PURCHASE_RETURN)}
              >
                <Tooltip
                  title={TITLES.PURCHASE_RETURN}
                  placement={"right-start"}
                >
                  <div>
                    <ListItemIcon>
                      <IconCrmDashboard />
                    </ListItemIcon>
                    <ListItemText className="menuText">
                      {TITLES.PURCHASE_RETURN}
                    </ListItemText>
                  </div>
                </Tooltip>
              </MenuItem>
            )}
          </List>
        </Collapse>

        {dmsReportsMenu && (
          <MenuItem
            className={
              "leftMenu " + (page === TITLES.DMS_REPORT ? "active" : "")
            }
            onClick={() => setPage(TITLES.DMS_REPORT)}
          >
            <Tooltip title={TITLES.DMS_REPORT} placement={"right-start"}>
              <div>
                <ListItemIcon>
                  <IconReports fontSize="small" />
                </ListItemIcon>
                <ListItemText className="menuText">
                  {TITLES.DMS_REPORT}
                </ListItemText>
              </div>
            </Tooltip>
          </MenuItem>
        )}

        <MenuItem
          className={"leftMenu " + (page === LABELS.SETTINGS ? "active" : "")}
          onClick={() => setPage(LABELS.SETTINGS)}
        >
          <Tooltip title={LABELS.SETTINGS} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconSettings fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">
                {LABELS.SETTINGS}
              </ListItemText>
            </div>
          </Tooltip>
        </MenuItem>

        <MenuItem
          className={"leftMenu " + (page === LABELS.LOGOUT ? "active" : "")}
          onClick={() => setLogoutPopup(!logoutPopup)}
        >
          <Tooltip title={LABELS.LOGOUT} placement={"right-start"}>
            <div>
              <ListItemIcon>
                <IconLogout fontSize="small" />
              </ListItemIcon>
              <ListItemText className="menuText">{LABELS.LOGOUT}</ListItemText>
            </div>
          </Tooltip>
        </MenuItem>
      </MenuList>

      <ConfirmDialog
        open={logoutPopup}
        title={LABELS.CONFIRM}
        msg={CONFIRMS.SURE_TO_LOGOUT}
        size={DEFAULTS.DIALOG_SIZE}
        onClose={() => setLogoutPopup(false)}
        onOk={onUserLogout}
      />
    </div>
  );
};

export default withSnackbar(LeftBar);
